var _animate, _animate2, _animate3, _animate4, _animate5, _animate6, _animate7, _animate8, _animate9, _animate10, _animate11, _animate12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 200,
      display: "block"
    },
    width: 10,
    height: 10,
    viewBox: "0 0 52 52",
    preserveAspectRatio: "xMidYMid",
    id: "svg50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g4",
    transform: "translate(-24,-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.655852,
      fill: "#0a0a0a"
    },
    id: "rect2"
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.9166666666666666s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30,82.78461,-6.7846097)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.739185,
      fill: "#0a0a0a"
    },
    id: "rect6"
  }, _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.8333333333333334s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60,58.78461,17.21539)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.822518,
      fill: "#0a0a0a"
    },
    id: "rect10"
  }, _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90,50,26)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.905852,
      fill: "#0a0a0a"
    },
    id: "rect14"
  }, _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.6666666666666666s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120,44.928203,31.071797)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.989185,
      fill: "#0a0a0a"
    },
    id: "rect18"
  }, _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5833333333333334s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150,41.21539,34.78461)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.072518,
      fill: "#0a0a0a"
    },
    id: "rect22"
  }, _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180,38,38)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.155852,
      fill: "#0a0a0a"
    },
    id: "rect26"
  }, _animate7 || (_animate7 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.4166666666666667s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-150,34.78461,41.21539)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.239185,
      fill: "#0a0a0a"
    },
    id: "rect30"
  }, _animate8 || (_animate8 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.3333333333333333s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-120,31.071797,44.928203)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.322518,
      fill: "#0a0a0a"
    },
    id: "rect34"
  }, _animate9 || (_animate9 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90,26,50)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.405852,
      fill: "#0a0a0a"
    },
    id: "rect38"
  }, _animate10 || (_animate10 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.16666666666666666s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-60,17.21539,58.78461)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.489185,
      fill: "#0a0a0a"
    },
    id: "rect42"
  }, _animate11 || (_animate11 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.08333333333333333s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30,-6.7846097,82.78461)",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto"
    },
    id: "g48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    rx: 3,
    ry: 3.5999999,
    width: 6,
    height: 12,
    fill: "#0a0a0a",
    style: {
      fontSize: 16,
      lineHeight: 24,
      fontFamily: "Roboto",
      inlineSize: 6,
      opacity: 0.572518,
      fill: "#0a0a0a"
    },
    id: "rect46"
  }, _animate12 || (_animate12 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.fb0333c1162047234c60ebcda6542045.svg";
export { ForwardRef as ReactComponent };